import { Sunrise, Sunset } from 'lucide-react';

function formatTime(isoTime: string): string {
  const date = new Date(isoTime);
  if (isNaN(date.getTime())) return '—';
  return date.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
}

interface HuntWindowDisplayProps {
  civilDawn: string;
  sunrise: string;
  sunset: string;
  civilDusk: string;
  compact?: boolean;
  /** 'grid-cell': minimal primary/secondary format for DataCockpit cells */
  variant?: 'default' | 'grid-cell';
}

export function HuntWindowDisplay({
  civilDawn,
  sunrise,
  sunset,
  civilDusk,
  compact = false,
  variant = 'default',
}: HuntWindowDisplayProps) {
  if (variant === 'grid-cell') {
    return (
      <div className="flex flex-col gap-0.5">
        <span className="text-[20px] font-bold text-[#e8e5e0] leading-tight">
          {formatTime(civilDawn)}
        </span>
        <span className="text-[12px] text-[#9a9590]">
          {formatTime(civilDusk)}
        </span>
      </div>
    );
  }

  if (compact) {
    return (
      <span className="text-body-sm text-[var(--color-text-primary)]">
        First light {formatTime(civilDawn)} · Last light {formatTime(civilDusk)}
      </span>
    );
  }

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center gap-2 text-body-sm text-[var(--color-text-primary)]">
        <Sunrise size={14} className="text-[var(--color-text-muted)] shrink-0" aria-hidden="true" />
        <span className="text-[var(--color-text-secondary)] w-36">First Light (Civil Dawn)</span>
        <span className="font-medium">{formatTime(civilDawn)}</span>
      </div>
      <div className="flex items-center gap-2 text-body-sm text-[var(--color-text-primary)]">
        <Sunrise size={14} className="text-[var(--color-text-muted)] shrink-0" aria-hidden="true" />
        <span className="text-[var(--color-text-secondary)] w-36">Sunrise</span>
        <span className="font-medium">{formatTime(sunrise)}</span>
      </div>
      <div className="flex items-center gap-2 text-body-sm text-[var(--color-text-primary)]">
        <Sunset size={14} className="text-[var(--color-text-muted)] shrink-0" aria-hidden="true" />
        <span className="text-[var(--color-text-secondary)] w-36">Sunset</span>
        <span className="font-medium">{formatTime(sunset)}</span>
      </div>
      <div className="flex items-center gap-2 text-body-sm text-[var(--color-text-primary)]">
        <Sunset size={14} className="text-[var(--color-text-muted)] shrink-0" aria-hidden="true" />
        <span className="text-[var(--color-text-secondary)] w-36">Last Light (Civil Dusk)</span>
        <span className="font-medium">{formatTime(civilDusk)}</span>
      </div>
    </div>
  );
}
